import { yesterday, isAfter } from "external/date-fns";
import { createPost } from "helpers/command";

const key = process.env.YOUTUBE_API_KEY
const channelId = process.env.DGENIUS_CHANNEL_ID
const baseURL = "https://www.googleapis.com/youtube/v3";

function createURL(endpoint, params = {}) {
    const url = new URL(`${baseURL}/${endpoint}`)
    const allParams = {...params, key, channelId} 
    const filteredParams = Object.entries(allParams).filter(([_, v]) => typeof(v) == 'string' && !(/^\s*$/.test(v)))
    for (const [k, v] of filteredParams) { url.searchParams.set(k, v) }
    return url.toString()
}

async function ytCall(endpoint, params = {}, filterFunction = () => true) {
    let results = []
    let pageToken = ""
    do {
    const url = createURL(endpoint, {...params, pageToken, maxResults: '50'})  
    const res = await fetch(url)
      if (!res.ok) {
          const text = await res.text()
          console.log(`YT Error: ${text}`)
          return []
          throw new Error(text)
      }
      const data = await res.json()
      results = results.concat(data.items)
      pageToken = data.nextPageToken || false
    } while(pageToken)
    
    return results.filter(filterFunction)
}

export async function getVideos(dashboardVideos) {
  const { whiteList, videos: settingVideos } = dashboardVideos

  const hasCurrentVideos = settingVideos.valid && isAfter(settingVideos.lastUpdated, yesterday())

  if (hasCurrentVideos) return settingVideos.items

  const filterWhitelistPlaylists = playlist => {
    if (whiteList.includes(playlist.snippet.title)) return true
    return false
  }

  const playlists = ((await ytCall('playlists', {part: 'contentDetails,snippet'}, filterWhitelistPlaylists)) || [])
    .map(({id}) => id)
  
  const mapVideosPromises = playlists.map(async (playlist) => {
    const videoParams = {part: 'snippet', playlistId: playlist}
    const videos = await ytCall('playlistItems', videoParams) || []
    return videos
  })

  const videos = await Promise.all(mapVideosPromises)
  const items = videos.flat()

  createPost('web', 'dashboardVideos')({ items })

  return items
}
